import * as React from 'react';
import { PosHistory } from './members.types';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { isPaymentDisabled, NOT_ENOUGH_PERMISSION_IMAGE } from '../util/permission.util';
import { BusinessState } from '../business/business.types';
import ReactTable from 'react-table';
import TextField from 'material-ui/TextField';

type PosHistoryTableData = {
  readonly transDate: String
  readonly description: string
  readonly total: number
  readonly transactionType: string
};

type Props = {
  readonly posHistories: Array<PosHistory>
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly businessState: BusinessState
};

type State = {
  readonly posHistories: Array<PosHistory>
  readonly filterByDescription: string
  readonly filterByType: string
};

class PosHistoriesComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      posHistories: props.posHistories,
      filterByType: '',
      filterByDescription: ''
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps) {
      this.setState({ posHistories: nextProps.posHistories });
    }
  }

  render() {
    return (
      <div>
        <div className="row ma2">
          <div className="col-auto">
            <TextField
              hintText="Filter By Description"
              floatingLabelText="Filter by Description"
              onChange={this.handleFilterByDescriptionChange}
            />
          </div>
          <div className="col-auto">
            <TextField
              hintText="Filter By Type"
              floatingLabelText="Filter by Type"
              onChange={this.handleFilterByTypeChange}
            />
          </div>
        </div>
        <div className="row ma2">
          <div className="col-12">
            {this.renderPaymentsHistoryTable()}
          </div>
        </div>
      </div>
    );
  }

  private handleFilterByDescriptionChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ filterByDescription: newValue.toLowerCase()})

  private handleFilterByTypeChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ filterByType: newValue.toLowerCase()})

  private renderPaymentsHistoryTable = (): JSX.Element => {
    if (isPaymentDisabled(this.props.authState, this.props.adminState)) {
      return(<img src={NOT_ENOUGH_PERMISSION_IMAGE} className="img-responsive img-thumbnail"/>);
    } else {
      return(
        <ReactTable
          data={this.getTableData()
            .filter(d => d.description.toLowerCase().includes(this.state.filterByDescription))
            .filter(d => d.transactionType.toLowerCase().includes(this.state.filterByType))
          }
          columns={
            [
              {
                Header: 'Date',
                accessor: 'transDate',
                style: {textAlign: 'center'}
              },
              {
                Header: 'Description',
                accessor: 'description',
                style: {textAlign: 'center'}
              },
              {
                Header: 'Total',
                accessor: 'total',
                style: {textAlign: 'center'}
              },
              {
                Header: 'Type',
                accessor: 'transactionType',
                style: {textAlign: 'center'}
              }
            ]
          }
          defaultPageSize={5}
          className="-striped -highlight"
        />
      );
    }
  }

  private getTableData = (): Array<PosHistoryTableData> => {
    return this.state.posHistories.map((posHistory: PosHistory) => { 
      return {
        transDate: posHistory.transDate,
        description: posHistory.description,
        total: posHistory.total,
        transactionType: posHistory.transactionType
      };
    });
  }

}

export default PosHistoriesComponent;



// WEBPACK FOOTER //
// ./src/members/PosHistoriesComponent.tsx